module.exports = __webpack_public_path__ + "static/rotate-c756870d550eb6134bdfe52661f7b456.png";